<template>
  <div>
    <div class="d-flex mb-5 justify-space-between">
      <v-spacer></v-spacer>
      <div class="d-flex">
        <v-btn v-if="canAddNew" color="primary text--white" @click="newConfiguration()">
          <v-icon left class="mr-4"> mdi-layers-plus </v-icon>
          {{ $t("addNewProductLabel") }}
        </v-btn>
        <div class="text-right ml-2">
          <v-btn @click="showFilters = !showFilters" color="primary">
            <template v-if="showFilters">
              <v-icon left>mdi-eye-off</v-icon>{{$t('hideFiltersLabel')}}
            </template>
            <template v-else>
              <v-icon left>mdi-eye</v-icon>
              {{$t('showFiltersLabel')}}
            </template>
          </v-btn>
        </div>
      </div>
    </div>
    <div class="mb-4" v-if="showFilters">
      <div class="body-1 mb-2">{{ $t("filterByLabel") }}</div>
      <div class="d-flex">
        <v-col class="col-3 pa-0">
          <v-card-text class="pa-0">
            <v-autocomplete class="mr-4" dense outlined v-model="selectedUser" :items="users" item-text="userName"
              item-value="userId" :label="$t('userLabel')" clearable hide-details>
            </v-autocomplete>
          </v-card-text>
        </v-col>
        <v-col cols="3" class="pa-0">
          <v-text-field hide-details class="mr-4" dense outlined clearable :label="$t('bestellnummerLabel')" v-model="purchNoFilter">
          </v-text-field>
        </v-col>
        <v-col cols="2" class="pa-0">
          <v-autocomplete hide-details class="mr-4" dense outlined v-model="selectedCompany" :items="companies"
            :label="$t('companyLabel')" item-text="companyName" item-value="companyId" clearable>
          </v-autocomplete>
        </v-col>
        <v-col cols="2" class="pa-0">
          <v-autocomplete class="mr-4" dense outlined v-model="selectedStatus" :items="statuses" item-text="name"
            item-value="value" :label="$t('statusLabel')" clearable hide-details>
          </v-autocomplete>
        </v-col>
        <v-col cols="2" class="pa-0 d-flex ml-auto">
          <div class="filter" style="width:100%">
            <v-btn @click="page = 1; filter(); filterEnabled();" class="" width="100%" color="primary" height="100%">
              <v-icon left>mdi-filter</v-icon> {{$t('filterLabel')}}
            </v-btn>
          </div>
          <div class="reset pl-4" v-if="filtered">
            <v-btn @click="page = 1; filterDisabled()" class="" width="100%" color="red" height="100%">
              <v-icon color="white">mdi-restore</v-icon>
            </v-btn>
          </div>
        </v-col>
      </div>
    </div>
    <v-data-table :footer-props="products.footerProps" :options.sync="options" :server-items-length="10" :headers="products.headers" :items="products.values" :loading="loading"
      :loading-text="$t('tableLoadingLabel')">
      <template #item.productConfigurationStatus="{ item }">
        <div v-if="item.productConfigurationStatus === inProgressStatus" class="text" :class="'red--text'">
          {{ $t("inProgressLabel") }}
        </div>
        <div v-else-if="item.productConfigurationStatus === readyForOrderStatus" class="text" :class="'warning--text'">
          {{ $t("readyForOrderLabel") }}
        </div>
        <div v-else-if="item.productConfigurationStatus === orderedStatus" class="text" :class="'green--text'">
        {{ $t("orderedStatusLabel") }}
        </div>
        <div v-else-if="item.productConfigurationStatus === offerStatus" class="text" :class="'grey--text'">
        {{ $t("offerLabel") }}
        </div>
      </template>
      <template #item.productConfigurationEntryDate="{ item }">
        <span>{{new Date(item.productConfigurationEntryDate).toLocaleString()}}</span>
      </template>
      <template v-if="canEdit" #item.actions="{ item }">
        <!-- <v-btn class="" outlined x-small fab color="primary mr-2" dark>
          <v-icon>mdi-notebook-edit</v-icon>
        </v-btn> -->
        <v-btn v-if="!isSPA" class="mr-4 primary--text" small outlined :to="{ name: 'Product' , params: { productId: item.id} }">
          {{ $t("openProductLabel") }}
        </v-btn>
        <v-btn v-else class="mr-4 primary--text" small outlined :to="{ name: 'SpaUserProductDetails' , params: { productId: item.id, companyId: spaCompanyId, userId: spaUserId} }">
          {{ $t("openProductLabel") }}
        </v-btn>
        <v-btn icon x-small outlined fab dark color="red" @click="deleteProductEventHandler(item)">
          <v-icon>mdi-trash-can</v-icon>
        </v-btn>
      </template>

      <template v-slot:no-data>
        {{$t('noDataAvailable')}}
      </template>
      <template v-slot:no-results>
        {{$t('noDataAvailable')}}
      </template>
    </v-data-table>
    <v-pagination v-model="page" :length="pageCount" @input="filter()"></v-pagination>
    <v-dialog v-model="deleteProductDialog" max-width="500px">
      <v-card class="pa-10">
        <v-card-title class="justify-center">{{
          $t("deleteProductTitle")
        }}</v-card-title>
        <p class="text-center">{{ $t("deleteProductDescription") }}</p>

        <v-card-actions>
          <v-row>
            <v-col cols="6">
              <v-btn @click="deleteConfiguration" width="100%" small color="red white--text">{{ $t('deleteConfigurationConfirm') }}</v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn width="100%" small color="primary" @click="deleteProductDialog = false">
                {{ $t("cancelLabel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  import {
    mapActions
  } from "vuex";
  import UserTypes from "../auth/userTypes";
  import StatusTypes from "../configurator/StatusTypes";
  export default {
    name: "ProductConfigurationsTable",
    data() {
      return {
        options:{},
        isSPA:false,
        spaCompanyId: '',
        spaUserId: '',
        showFilters:false,
        filtered: false,
        amount: 10,
        deleteProductDialog: false,
        page: 1,
        pageCount: 1,
        sortBy: 'productConfigurationEntryDate',
        sortDesc: true,
        selectedUser: "",
        purchNoFilter: '',
        selectedCompany: "",
        selectedStatus: "",
        companies: [],
        selectedProductId: '',
        users: [],
        inProgressStatus: StatusTypes.InProgress,
        readyForOrderStatus: StatusTypes.ReadyForOrder,
        orderedStatus: StatusTypes.Ordered,
        offerStatus: StatusTypes.Offer,
        statuses: [{
            name: this.$t('inProgressLabel'),
            value: StatusTypes.InProgress,
          },
          {
            name: this.$t('readyForOrderLabel'),
            value: StatusTypes.ReadyForOrder,
          },
          {
            name: this.$t('orderedStatusLabel'),
            value: StatusTypes.Ordered,
          },
          {
            name: this.$t('offerLabel'),
            value: StatusTypes.Offer,
          },
        ],
        loading: true,
        products: {
          inProgress: 0,
          readyForOrder: 0,
          ordered: 0,
          search: "",
          headers: [
            {
              text: this.$t('productIdLabel'),
              value: "productConfigurationConfigurationId",
              // width: '15%',
            },
            {
              text: this.$t('entryDateLabel'),
              value: "productConfigurationEntryDate",
              width: '10%',
            },
            {
              text: this.$t('bestellnummerLabel'),
              value: "purchValue",
              width: '10%',
            },
            {
              text: this.$t('productCreatedByLabel'),
              value: "userLastName",
              width: '12%',
            },
            {
              text: this.$t('productCompanyLabel'),
              value: "companyName",
              width: '10%',
            },
            {
              text: this.$t('productStatusLabel'),
              value: "productConfigurationStatus",
              width: '10%',
            },
            {
              text: "",
              sortable: false,
              value: "actions",
              align: "end",
              width: '20%',
            },
          ],
          values: [],
          footerProps:{
            'items-per-page-options' : [5, 10, 15, 20, -1],
            'disable-pagination': true,
            'next-icon': null,
            'prev-icon': null,
            'page-text' : '',
            'items-per-page-all-text': this.$t('allLabel'),
            'items-per-page-text': this.$t('rowsPerPageLabel')
          }
        },
        pagination: {
          rowsPerPage: 5
        },
        snackbar: {
          show: true,
          message: "",
        }
      };
    },
    props: {
      companyId: Number,
      userId: Number,
      canEdit: Boolean,
      canAddNew: Boolean,
      getByUser: Boolean,
      getByCompany: Boolean,
      includeAffiliates: Boolean,
    },
    watch: {
      options: {
        handler(){
          const options = this.options;
          this.amount = options.itemsPerPage;
          const sortBy = options.sortBy.length > 0 ? options.sortBy[0] : this.sortBy;
          const sortDesc = options.sortDesc.length > 0 ? options.sortDesc[0] : this.sortDesc;
          this.sortBy = sortBy;
          this.sortDesc = sortDesc;
          this.filter();
        },
        deep: true
      }
    },
    methods: {
      ...mapActions("configuratorModule", ["setProductId"]),

      getProductConfigurations() {
        this.loading = true

        const WertheimAdmin = {
          isWertheimSales: false,
          isSalesPartnershipAdmin: false,
          isSalesPartnershipSales: false,
          isSalesPartnershipProductConfigurator: false,
          isAffiliatePartnershipSales: false,
          amount: this.amount,
          selectedCompanyId: this.selectedCompany ? this.selectedCompany : '',
          selectedUserId: this.selectedUser ? this.selectedUser : '',
          purchNo: this.purchNoFilter ? this.purchNoFilter : '',
          status: this.selectedStatus ? this.selectedStatus : '',
          startDate: '',
          endDate: '',
          page: this.page,
        }
        const WertheimSales = {
          isWertheimSales: true,
          isSalesPartnershipAdmin: false,
          isSalesPartnershipSales: false,
          isSalesPartnershipProductConfigurator: false,
          isAffiliatePartnershipSales: false,
          amount: this.amount,
          selectedCompanyId: this.selectedCompany ? this.selectedCompany : '',
          selectedUserId: this.selectedUser ? this.selectedUser : '',
          purchNo: this.purchNoFilter ? this.purchNoFilter : '',
          status: this.selectedStatus ? this.selectedStatus : '',
          startDate: '',
          endDate: '',
          page: this.page,
        }
        const SalesPartnershipAdmin = {
          isWertheimSales: false,
          isSalesPartnershipAdmin: true,
          isSalesPartnershipSales: false,
          isSalesPartnershipProductConfigurator: false,
          isAffiliatePartnershipSales: false,
          amount: this.amount,
          companyId: this.companyId,
          spPartnerCompanyId: this.selectedCompany ? this.selectedCompany : '',
          userId: this.selectedUser ? this.selectedUser : '',
          purchNo: this.purchNoFilter ? this.purchNoFilter : '',
          status: this.selectedStatus ? this.selectedStatus : '',
          startDate: '',
          endDate: '',
          page: this.page,
        }
        const SalesPartnershipSales = {
          //smundet me filtru me kompani
          isWertheimSales: false,
          isSalesPartnershipAdmin: false,
          isSalesPartnershipSales: true,
          isSalesPartnershipProductConfigurator: false,
          isAffiliatePartnershipSales: false,
          amount: this.amount,
          companyId: '',
          spPartnerCompanyId: this.selectedCompany ? this.selectedCompany : '',
          userId: this.userId,
          purchNo: this.purchNoFilter ? this.purchNoFilter : '',
          status: this.selectedStatus ? this.selectedStatus : '',
          startDate: '',
          endDate: '',
          page: this.page,
        }
        const AffiliatePartnershipSales = {
          //nuk mundet me filtru me kompani
          isWertheimSales: false,
          isSalesPartnershipAdmin: false,
          isSalesPartnershipSales: false,
          isSalesPartnershipProductConfigurator: false,
          isAffiliatePartnershipSales: true,
          amount: this.amount,
          companyId: '',
          userId: this.userId,
          purchNo: this.purchNoFilter ? this.purchNoFilter : '',
          status: this.selectedStatus ? this.selectedStatus : '',
          startDate: '',
          endDate: '',
          page: this.page,
        }
        const SalesPartnershipProductConfigurator = {
          //nuk mundet me filtru me kompani
          isWertheimSales: false,
          isSalesPartnershipAdmin: false,
          isSalesPartnershipSales: false,
          isSalesPartnershipProductConfigurator: true,
          isAffiliatePartnershipSales: false,
          amount: this.amount,
          companyId: '',
          userId: this.userId,
          purchNo: this.purchNoFilter ? this.purchNoFilter : '',
          status: this.selectedStatus ? this.selectedStatus : '',
          startDate: '',
          endDate: '',
          page: this.page,
        }

        var dataParams;

        if (this.$store.state.user.userType == UserTypes.WertheimSales) {
          dataParams = WertheimSales
        } else if (this.$store.state.user.userType == UserTypes.SalesPartnershipAdmin) {
          dataParams = SalesPartnershipAdmin
        } else if (this.$store.state.user.userType == UserTypes.SalesPartnershipSales) {
          dataParams = SalesPartnershipSales
        } else if (this.$store.state.user.userType == UserTypes.AffiliatePartnershipSales) {
          dataParams = AffiliatePartnershipSales
        } else if (this.$store.state.user.userType == UserTypes.SalesPartnershipProductConfigurator) {
          dataParams = SalesPartnershipProductConfigurator
        } else {
          dataParams = WertheimAdmin
        }

        dataParams.sortBy = this.sortBy;
        dataParams.sortDesc = this.sortDesc;

        this.axios
          .get("api/productconfiguration/filterProductConfigurations", {
            params: dataParams
          })
          .then((response) => {
            if (!this.companies.length) {
              this.companies = response.data.companies;
            }
            // console.log(response.data.users)
            if (!this.users.length) {
              this.users = response.data.users;
            }
            this.products.values = response.data.filteredProductConfigurations
            this.loading = false,
              this.pageCount = response.data.pages;
            this.loading = false;
            // this.loading = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      },
      filter() {
        this.getProductConfigurations()
      },
      filterEnabled() {
        this.filtered = true
      },
      filterDisabled() {
        this.filtered = false
        this.selectedCompany = ''
        this.selectedUser = ''
        this.purchNoFilter = ''
        this.selectedStatus = ''
        this.filter()
      },
      // getProductConfigurationsByCompany() {
      //   this.axios
      //     .get("api/productconfiguration/getProductConfigurationsByCompany", {
      //       params: {
      //         companyId: this.$props.companyId,
      //       },
      //     })
      //     .then((response) => {
      //       this.products.values = response.data;
      //       this.loading = false;
      //     })
      //     .catch((error) => {
      //       console.log(error);
      //       this.loading = false;
      //     });
      // },
      // getProductConfigurationsByCompanyIncludeAffiliates() {
      //   this.axios
      //     .get(
      //       "api/productconfiguration/getProductConfigurationsByCompanyIncludeAffiliates", {
      //         params: {
      //           companyId: this.$props.companyId,
      //         },
      //       }
      //     )
      //     .then((response) => {
      //       this.products.values = response.data;
      //       this.loading = false;
      //     })
      //     .catch((error) => {
      //       console.log(error);
      //       this.loading = false;
      //     });
      // },
      // getProductConfigurationsByUser() {
      //   this.axios
      //     .get("api/productconfiguration/getProductConfigurationsByUser", {
      //       params: {
      //         userId: this.$props.userId,
      //       },
      //     })
      //     .then((response) => {
      //       this.products.values = response.data;
      //       this.loading = false;
      //     })
      //     .catch((error) => {
      //       console.log(error);
      //       this.loading = false;
      //     });
      // },

      newConfiguration() {
        this.setProductId(0);
        this.$router.push("/product-configurator");
      },
      deleteProductEventHandler(product) {
        this.deleteProductDialog = true;
        this.selectedProductId = product.id
      },
      deleteConfiguration() {
        this.axios
          .delete("/api/productConfiguration/delete", {
            params: {
              id: this.selectedProductId,
            },
          })
          .then((response) => {
            let index = this.products.values.findIndex(x => x.id == this.selectedProductId);
            this.products.values.splice(index, 1)
            this.deleteProductDialog = false
            this.snackbar.message = this.$t("productDeletedLabel");
            this.$EventBus.$emit("snackbar", this.snackbar);
            // this.getProductConfigurations()
          })
          .catch((error) => {
            this.snackbar.message = this.$t("productCannotDeletedLabel");
            this.$EventBus.$emit("snackbar", this.snackbar);
            console.log(error);
          });
      },
      checkSpa(){
        if(this.$route.fullPath.includes('sale-partnerships')){
          this.isSPA = true
        }
        else{
          this.isSPA = false
        }
        this.spaCompanyId = this.$route.params.companyId
        this.spaUserId = this.$route.params.userId
      }
    },
    mounted() {
      this.checkSpa();
      // if (this.$props.getByUser) {
      //   this.getProductConfigurationsByUser();
      // } else if (this.$props.includeAffiliates && this.$props.getByCompany) {
      //   this.getProductConfigurationsByCompanyIncludeAffiliates();
      // } else if (this.$props.getByCompany) {
      //   this.getProductConfigurationsByCompany();
      // } else {
      //   this.getProductConfigurations();
      // }

      // this.getProductConfigurations();

      this.readyForOrder = StatusTypes.ReadyForOrder;
      this.inProgress = StatusTypes.InProgress;
      this.ordered = StatusTypes.Ordered;
    },
    computed: {
      dateRangeText() {
        return this.dates.join(" ~ ");
      },
    },
  };
</script>
<style scoped>
</style>